import type {SketchLineObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchLineRelationConstraint} from './SketchLineRelationConstraint';

let count = 0;

/**
 * 判断对象是否为水平关系。
 * @param value 待判断对象。
 * @returns 是否为水平关系。
 */
export function isLineHorizontalConstraint(value: object): value is LineHorizontalConstraint {
    return Reflect.get(value, 'isLineHorizontalConstraint') === true;
}

/**
 * 直线水平关系定义。
 *
 * 几何计算由统一参数公式完成；本类只保存关系类型、目标绑定与显示身份。
 */
export class LineHorizontalConstraint extends SketchLineRelationConstraint<SketchLineObject> {
    /** 运行时类型标记。 */
    public readonly isLineHorizontalConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Horizontal;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '水平';
    }
}
